import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import { useGetAllTariffsQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { All_TARIFFS_COUNT_PER_REQUEST } from 'Util/constants'

function useAllTariffs() {
  const { selectedAuthorityCode } = useAuthorityContext()
  const selectedPtaFilter = selectedAuthorityCode ? `pta eq "${selectedAuthorityCode}"` : undefined
  const { data, isLoading } = useGetAllTariffsQuery({
    bypass_pagination: true,
    count: All_TARIFFS_COUNT_PER_REQUEST,
    filter: selectedPtaFilter
  })

  return {
    allTariffs: data?.resources || [],
    isAllTariffsLoading: isLoading,
    totalResults: data?.total_results || 0
  }
}

export default useAllTariffs
